import Image from 'next/legacy/image';
import { useEffect } from 'react';

import secondCardImg from '/public/images/graduate/calander.svg';
import fourthCardImg from '/public/images/graduate/coding_icon.svg';
import firstCardImg from '/public/images/graduate/sand_watch.svg';
import thirdCardImg from '/public/images/graduate/smile.svg';
import { animateValue } from '@/lib/utils/businessLogics/graduate';

import * as S from './style';

export default function Report({
  studyTime,
  teamMates,
  speciality,
}: {
  studyTime: number;
  teamMates: number;
  speciality: string;
}) {
  const studyHrs = Math.round(studyTime / 3600);

  useEffect(() => {
    const animatedNumbers = Array.from(
      document.getElementsByClassName('animatedNumber'),
    );
    animatedNumbers.map((obj) => animateValue(obj, 0, obj.textContent, 4500));
  }, []);

  return (
    <>
      <S.Title>항해 여정 리포트</S.Title>
      <S.CardWrapper>
        <S.Card>
          <S.CardText>
            <S.CardImg>
              <Image src={firstCardImg} alt='hourglass' />
            </S.CardImg>
            누적 학습 시간
            <S.CardData>
              <span className='animatedNumber'>{studyHrs}</span>시간
            </S.CardData>
          </S.CardText>
        </S.Card>
        <S.Card>
          <S.CardText>
            <S.CardImg>
              <Image src={secondCardImg} alt='calendar' />
            </S.CardImg>
            누적 학습일
            <S.CardData>
              <span className='animatedNumber'>99</span>일
            </S.CardData>
          </S.CardText>
        </S.Card>
        <S.Card>
          <S.CardText>
            <S.CardImg>
              <Image src={thirdCardImg} alt='smile' />
            </S.CardImg>
            함께한 팀원 수
            <S.CardData>
              <span className='animatedNumber'>{teamMates}</span>명
            </S.CardData>
          </S.CardText>
        </S.Card>
        <S.Card>
          <S.CardText>
            <S.CardImg>
              <Image src={fourthCardImg} alt='coding' />
            </S.CardImg>
            주특기
            <S.CardData>{speciality}</S.CardData>
          </S.CardText>
        </S.Card>
      </S.CardWrapper>
    </>
  );
}
